import api from './api';

export const twofaService = {
  // Get 2FA status
  get2FAStatus: async () => {
    const response = await api.get('/2fa/status');
    // Backend returns is_enabled, map it to is_2fa_enabled for consistency
    return {
      is_2fa_enabled: response.data.is_enabled
    };
  },

  // Setup 2FA - returns QR code, secret, and backup codes
  enable2FA: async () => {
    const response = await api.post('/2fa/setup');
    return response.data;
  },

  // Verify and activate 2FA with TOTP code
  confirm2FA: async (totpCode) => {
    const response = await api.post('/2fa/verify', { code: totpCode });
    return response.data;
  },

  // Disable 2FA
  disable2FA: async (totpCode) => {
    const response = await api.post('/2fa/disable', { code: totpCode });
    return response.data;
  },

  // Regenerate backup codes
  regenerateBackupCodes: async (totpCode) => {
    const response = await api.post('/2fa/regenerate-backup-codes', { code: totpCode });
    return response.data;
  },
};
